<div class="pay-confirmation text-center"> 
    <div class="msg">
        <span class="check-wrap">
            <img src="assets/images/tick.png" alt="checked">
        </span>
        <h3>
            <p class="colorTheme ">
                Your account is already active. Please sign out by visiting mylifewell.com to create a new account
            </p>
            <br>
        </h3>
    </div>
  </div>

